import { render } from "./QualificationDashboard.vue?vue&type=template&id=61986c39&ts=true"
import script from "./QualificationDashboard.vue?vue&type=script&lang=ts"
export * from "./QualificationDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__